import { useAccountContext } from '@/context/account'
import type { Network } from '@vaultsfyi/common/types'
import { getChainId } from '@vaultsfyi/common/utils'
import type { Address } from 'viem'
import { useConfig } from 'wagmi'
import { getCapabilities } from 'wagmi/actions'

async function checkBatchSupported(
  config: ReturnType<typeof useConfig>,
  account: Address,
  network: Network
): Promise<boolean> {
  if (!account) return false

  try {
    const capabilities = await getCapabilities(config, { account })
    const chainId = getChainId(network)

    const v1BatchSupported = capabilities?.[chainId]?.atomicBatch?.supported
    const v2BatchStatus = capabilities?.[chainId]?.atomic?.status
    const v2BatchSupported = v2BatchStatus === 'supported' || v2BatchStatus === 'ready'

    return v1BatchSupported || v2BatchSupported || false
  } catch {
    return false
  }
}

export function useBatchSupported(network: Network) {
  const { account } = useAccountContext()
  const config = useConfig()

  const checkSupport = () => checkBatchSupported(config, account as Address, network)

  return { checkBatchSupported: checkSupport }
}
